import type { Bookmark, BookmarkCategory } from "../types";

export const categories: BookmarkCategory[] = [
  "Public",
  "Server",
  "Storage",
  "Monitoring",
  "AI",
  "Network",
  "Tool"
];

export const iconOptions = [
  "activity",
  "box",
  "database",
  "folder",
  "globe",
  "graph",
  "hard-drive",
  "home",
  "lock",
  "music",
  "network",
  "rocket",
  "server",
  "shield",
  "spark",
  "terminal",
  "waves",
  "workflow"
];

export const defaultBookmarks: Bookmark[] = [
  {
    id: "firstcallmusic",
    label: "FirstCall Music",
    url: "https://firstcallmusic.net/",
    category: "Public",
    icon: "globe",
    accent: "#ffffff",
    description: "Public music website",
    status: "online"
  },
  {
    id: "studio-vibes",
    label: "Studio Vibes",
    url: "https://studiovibes.net/",
    category: "Public",
    icon: "music",
    accent: "#ff9bd6",
    description: "Studio Vibes public site",
    status: "online"
  },
  {
    id: "vectune-net",
    label: "Vectune.net",
    url: "https://vectune.net/",
    category: "Public",
    icon: "waves",
    accent: "#6df7ff",
    description: "Vectune public site",
    status: "online"
  },
  {
    id: "vectune",
    label: "Vectune",
    url: "https://vectune.fcm.plus/",
    category: "Public",
    icon: "waves",
    accent: "#8ee8ff",
    description: "Cloudflare Access protected music search",
    status: "protected"
  },
  {
    id: "vectune-suno",
    label: "Vectune Suno",
    url: "https://vectune.fcm.plus/suno/",
    category: "Tool",
    icon: "music",
    accent: "#ff7bd5",
    description: "Suno workflow inside Vectune",
    status: "protected"
  },
  {
    id: "umbrel",
    label: "Umbrel",
    url: "https://umbrel.fcm.plus/",
    category: "Public",
    icon: "box",
    accent: "#c4d7ff",
    description: "Bitcoin node public entry",
    status: "protected"
  },
  {
    id: "grafana",
    label: "Grafana",
    url: "https://grafana.fcm.plus/",
    category: "Monitoring",
    icon: "graph",
    accent: "#ffb152",
    description: "117 monitoring dashboards",
    status: "protected"
  },
  {
    id: "m-home-syslog",
    label: "m-home Syslog",
    url: "https://m-home-syslog.fcm.plus/",
    category: "Monitoring",
    icon: "terminal",
    accent: "#7bf1a8",
    description: "LAN/Tailscale syslog edge",
    status: "local"
  },
  {
    id: "mira",
    label: "Mira",
    url: "https://mira.fcm.plus/",
    category: "AI",
    icon: "spark",
    accent: "#78e5a1",
    description: "AI service dashboard",
    status: "protected"
  },
  {
    id: "compath",
    label: "Compath",
    url: "https://compath.fcm.plus/",
    category: "Public",
    icon: "rocket",
    accent: "#f0a2ff",
    description: "Cloudflare Access app",
    status: "protected"
  },
  {
    id: "hope-proof-os",
    label: "Hope Proof OS",
    url: "https://hope.fcm.plus/proof-os/",
    category: "Tool",
    icon: "workflow",
    accent: "#d9ff73",
    description: "Hope proof OS workflow",
    status: "protected"
  },
  {
    id: "firstcall-admin",
    label: "FirstCall Admin",
    url: "https://firstcall-admin.fcm.plus/",
    category: "Public",
    icon: "shield",
    accent: "#ffffff",
    description: "Admin origin via Cloudflare",
    status: "unknown"
  },
  {
    id: "reader-tts",
    label: "Reader TTS",
    url: "https://reader-tts.fcm.plus/",
    category: "Tool",
    icon: "spark",
    accent: "#a4b4ff",
    description: "Reader text-to-speech app",
    status: "protected"
  },
  {
    id: "shachi-red",
    label: "Shachi RED",
    url: "https://shachi-red.fcm.plus/",
    category: "Public",
    icon: "music",
    accent: "#ff4e58",
    description: "Studio Vibes assistant",
    status: "protected"
  },
  {
    id: "booking",
    label: "Booking",
    url: "https://booking.fcm.plus/",
    category: "Public",
    icon: "workflow",
    accent: "#77d6ff",
    description: "Studio booking app",
    status: "online"
  },
  {
    id: "immich",
    label: "Immich",
    url: "https://immich.fcm.plus/",
    category: "Storage",
    icon: "home",
    accent: "#69c8ff",
    description: "Photo library",
    status: "protected"
  },
  {
    id: "pfsense",
    label: "pfSense",
    url: "https://172.16.30.1/",
    category: "Network",
    icon: "network",
    accent: "#ff8a7a",
    description: "LAN gateway",
    status: "local"
  },
  {
    id: "proxmox-201",
    label: "Proxmox 201",
    url: "https://172.16.30.201:8006/",
    category: "Server",
    icon: "server",
    accent: "#ff9f43",
    description: "Main Proxmox host",
    status: "local"
  },
  {
    id: "proxmox-202",
    label: "Proxmox 202",
    url: "https://172.16.30.202:8006/",
    category: "Server",
    icon: "server",
    accent: "#ffd166",
    description: "Secondary Proxmox host",
    status: "local"
  },
  {
    id: "proxmox-203",
    label: "Proxmox 203",
    url: "https://172.16.30.203:8006/",
    category: "Server",
    icon: "server",
    accent: "#ef476f",
    description: "PostgreSQL VM host",
    status: "local"
  },
  {
    id: "monitoring-117",
    label: "Monitor 117",
    url: "http://172.16.30.117/",
    category: "Monitoring",
    icon: "activity",
    accent: "#7bf1a8",
    description: "Grafana/Loki/Prometheus VM",
    status: "local"
  },
  {
    id: "uptime-kuma",
    label: "Uptime Kuma",
    url: "http://172.16.30.119/",
    category: "Monitoring",
    icon: "activity",
    accent: "#55ff99",
    description: "Availability checks",
    status: "local"
  },
  {
    id: "postgres-106",
    label: "DB 106",
    url: "http://172.16.30.106/",
    category: "Server",
    icon: "database",
    accent: "#98c1ff",
    description: "PostgreSQL / app DB VM",
    status: "local"
  },
  {
    id: "true-nas",
    label: "TrueNAS",
    url: "http://172.16.30.101/",
    category: "Storage",
    icon: "hard-drive",
    accent: "#77d8ff",
    description: "Core storage",
    status: "local"
  },
  {
    id: "truenas-public",
    label: "TrueNAS Cloud",
    url: "https://truenas.fcm.plus/",
    category: "Storage",
    icon: "hard-drive",
    accent: "#5fd7ff",
    description: "TrueNAS public entry",
    status: "protected"
  },
  {
    id: "qnap-120",
    label: "QNAP 120",
    url: "http://172.16.30.120/",
    category: "Storage",
    icon: "folder",
    accent: "#62e17b",
    description: "BOX clone / sync NAS",
    status: "local"
  },
  {
    id: "m-station-121",
    label: "m-station",
    url: "http://172.16.30.121/",
    category: "Storage",
    icon: "folder",
    accent: "#a9f5ff",
    description: "Main QNAP NAS",
    status: "local"
  },
  {
    id: "synology-122",
    label: "Synology",
    url: "http://172.16.30.122/",
    category: "Storage",
    icon: "hard-drive",
    accent: "#9be7ff",
    description: "Archive / photo NAS",
    status: "local"
  },
  {
    id: "rag-125",
    label: "RAG 125",
    url: "http://172.16.30.125/",
    category: "AI",
    icon: "spark",
    accent: "#b8ff6d",
    description: "AI/RAG/Ollama host",
    status: "local"
  },
  {
    id: "ocr-110",
    label: "OCR 110",
    url: "http://172.16.30.110/",
    category: "AI",
    icon: "workflow",
    accent: "#a4b4ff",
    description: "NDLOCR-Lite VM",
    status: "local"
  },
  {
    id: "suno-108",
    label: "Suno 108",
    url: "http://172.16.30.108:3000/",
    category: "Tool",
    icon: "music",
    accent: "#ff7bd5",
    description: "Ubuntu desktop utility VM",
    status: "local"
  },
  {
    id: "tv-guide-108",
    label: "テレビ番組表",
    url: "http://172.16.30.108:3031/",
    category: "Tool",
    icon: "globe",
    accent: "#ffd166",
    description: "Local-only TV schedule on 108",
    status: "local"
  },
  {
    id: "win-ai-103",
    label: "AI 103",
    url: "http://172.16.30.103:8001/",
    category: "AI",
    icon: "terminal",
    accent: "#44d7ff",
    description: "RTX 4090 worker",
    status: "local"
  },
  {
    id: "sec-105",
    label: "Sec 105",
    url: "http://172.16.30.105/",
    category: "Tool",
    icon: "lock",
    accent: "#f7ff8a",
    description: "Security / utility workstation",
    status: "local"
  }
];
